import React, { useEffect, useRef } from "react";
import { bool, func, string } from "prop-types";
import { useTranslation } from "@lib/i18n";

import { Button } from "./Button";
import Typography from "./Typography";
import SimpleButton from "./SimpleButton";
import Modal from "./Modal";

export const CEE_UNAVAILABLE_MODAL_TYPE = {
  BUSINESS_MODEL: "BUSINESS_MODEL",
  FINANCING_JOURNEY: "FINANCING_JOURNEY",
};

const MODAL_TYPE_KEY = {
  BUSINESS_MODEL: "businessModel",
  FINANCING_JOURNEY: "financingJourney",
};

const CEEUnavailableModal = ({ isOpen, onConfirm, onCancel, dataId, type }) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef(null);
  const modalLastElement = useRef(null);

  const isInvalidType = !Object.values(CEE_UNAVAILABLE_MODAL_TYPE).includes(
    type
  );

  useEffect(() => {
    if (isOpen && isInvalidType) {
      // Unblock the journey
      onConfirm();
    }
  }, [isOpen]);

  // Skip the render
  if (isInvalidType) {
    return null;
  }

  const typeKey = MODAL_TYPE_KEY[type];

  return (
    <Modal
      isOpen={isOpen}
      ariaLabel={t(`ceeSubsidyUnavailableModal.${typeKey}.heading`)}
      firstElement={modalFirstElement}
      lastElement={modalLastElement}
      onClose={onCancel}
    >
      <div
        className="flex flex-col items-center h-full gap-8 py-4 text-center"
        data-id={`${dataId}-modal-container`}
      >
        <h4 className="text-xl font-semibold">
          {t(`ceeSubsidyUnavailableModal.${typeKey}.heading`)}
        </h4>
        <Typography>
          {t(`ceeSubsidyUnavailableModal.${typeKey}.description`)}
        </Typography>
        <div className="flex flex-wrap items-center justify-center gap-4 w-full">
          <Button
            ref={modalFirstElement}
            onClick={onCancel}
            data-id={`${dataId}-change-cancel-btn`}
          >
            {t(`ceeSubsidyUnavailableModal.${typeKey}.stay`)}
          </Button>
          <SimpleButton
            ref={modalLastElement}
            onClick={onConfirm}
            dataId={`${dataId}-change-confirm-btn`}
            className="m-0 p-4"
          >
            {t(`ceeSubsidyUnavailableModal.${typeKey}.continue`)}
          </SimpleButton>
        </div>
      </div>
    </Modal>
  );
};

CEEUnavailableModal.propTypes = {
  isOpen: bool.isRequired,
  type: string.isRequired,
  onConfirm: func,
  onCancel: func,
  dataId: string,
};

export default CEEUnavailableModal;
